import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import DashboardPage from '../components/Dashboard/DashboardPage';
import Footer from '../components/General/Footer';
import { getUser } from '../helpers/token';
import withApollo from '../lib/withApollo';
import Monetization from 'components/Dashboard/Monetization';

const IntegrationsPage = () => {
  const router = useRouter();

  const [user, setUser] = useState(null);

  useEffect(() => {
    setUser(getUser());
  }, []);

  const { open } = router.query;

  const generatedOgImage = `https://tfog.b-cdn.net/api/post?title=${encodeURIComponent(
    'How To Make Money With a Travel Blog',
  )}&image=${encodeURIComponent(
    'https://img.travelfeed.io/jpphotography%2F2023-09-25-13-09-512-travel-blog-affiliate-marketing-jpg',
  )}`;

  return (
    <>
      <DashboardPage
        ogImage={generatedOgImage}
        justTitle="How To Make Money With a Travel Blog"
        description="Discover top strategies to make money with your travel blog. Monetize your blog with affiliate marketing, ads, and Hive rewards. Turn passion into profit."
        showForAnyone
        open={open}
        label="monetization"
        content={
          <>
            <Monetization />
            {user === undefined && <Footer />}
          </>
        }
      />
    </>
  );
};

export default withApollo(IntegrationsPage);
